const openSand = `font-family: "Open Sans","Arial","Helvetica Neue","Helvetica","sans-serif",-apple-system,system-ui;`;
const flama = `font-family: "Flama","Arial","Helvetica Neue","Helvetica","sans-serif",-apple-system,system-ui;`;

const typography = {
    title1: ()=> `
        ${flama}
        font-size: 28px;
        font-weight: 700;
        line-height: 1.5;
    `,
    title2: ()=> `
        ${flama}
        font-size: 26px;
        font-weight: 700;
        line-height: 1.5;
    `,
    title3: ()=> `
        ${flama}
        font-size: 24px;
        font-weight: 700;
        line-height: 1.5;
    `,
    title4: ()=> `
        ${flama}
        font-size: 20px;
        line-height: 1.5;
    `,
    title5: ()=> `
        ${flama}
        font-size: 18px;
        line-height: 1.5;
    `,
    title6: ()=> `
        ${flama}
        font-size: 18px;
        line-height: 1.5;
        font-weight: 600;
    `,
    title7: ()=> `
        ${flama}
        font-size: 16px;
        line-height: 1.5;
    `,
    title8: ()=> `
        ${flama}
        font-size: 16px;
        line-height: 1.5;
        font-weight: 600;
    `,
    body1: ()=> `
        ${openSand}
        font-size: 16px;
        font-weight: 600;
        line-height: 1.88;
    `,
    body2: ()=> `
        ${openSand}
        font-size: 16px;
        line-height: 1.88;
    `,
    body3: ()=> `
        ${openSand}
        font-size: 15px;
        font-weight: 600;
        line-height: 1.6;
    `,
    body4: ()=> `
        ${openSand}
        font-size: 15px;
        line-height: 1.6;
    `,
    body5: ()=> `
        ${openSand}
        font-size: 14px;
        font-weight: 600;
        line-height: 1.5;
    `,
    body6: ()=> `
        ${openSand}
        font-size: 14px;
        font-weight: 600;
        line-height: 1.71;
    `,
    body7: ()=> `
        ${openSand}
        font-size: 14px;
        line-height: 1.71;
    `,
    body8: ()=> `
        ${openSand}
        font-size: 12px;
        font-weight: 600;
        line-height: 1.5;
    `,
    body9: ()=> `
        ${openSand}
        font-size: 12px;
        line-height: 1.5;
    `,
    body10: ()=> `
        ${openSand}
        font-size: 12px;
        font-weight: 600;
        line-height: 1.67;
    `,
    body11: ()=> `
        ${openSand}
        font-size: 12px;
        line-height: 1.67;
    `
};

export default typography;
